document.addEventListener('DOMContentLoaded', () => {

  // Footer Social Icon Start  
    const footersocial = document.querySelector('.footer-block--newsletter');
    const footerlogosocial = document.querySelector('.footer-block-image');

    if (footersocial && footerlogosocial) {
        footerlogosocial.insertAdjacentElement('afterend', footersocial);
    }
  // Footer Social Icon End

  // Footer Description Start
    const footerdesc = document.querySelector('.after-signup-show .footer-description');
      const footerlogodesc = document.querySelector('.footer-block-image');
  
      if (footerdesc && footerlogodesc) {
          footerlogodesc.insertAdjacentElement('afterend', footerdesc);
      }
   // Footer Description End

      // Add R symbol Start
      document.querySelectorAll('p').forEach(p => {
        p.innerHTML = p.innerHTML.replace(/\bLuxFresh\b(?!®)/g, '<span class="register-symbol">LuxFresh®</span>');
      });
      // document.querySelectorAll('*').forEach(el => {
      //   if (el.children.length === 0 && el.innerHTML.includes('LuxFresh')) {
      //     el.innerHTML = el.innerHTML.replace(/\bLuxFresh\b(?!®)/g, '<span class="register-symbol">LuxFresh®</span>');
      //   }
      // });

  
      // document.querySelectorAll('.image-with-text__text p').forEach(p => {
      //   p.innerHTML = p.innerHTML.replace(/\b(LuxFresh)\b/g, '<span class="register-symbol">$1</span>');
      // });
      // Add R symbol End

      // Add Anchor Tag Start
       // document.querySelectorAll('.image-with-text__text p').forEach(p => {
       //  p.innerHTML = p.innerHTML.replace(/(wholesale and branded opportunities\.)/gi, '<a href="#" class="register-link">$1</a>');
       // });
    
      // document.querySelectorAll('.rich-text__text p').forEach(p => {
      //   const regex = /\bnewsletter\b/i;
      //   if (regex.test(p.textContent)) {
      //     p.innerHTML = p.innerHTML.replace(regex, '<a href="#" class="newsletter-link">newsletter</a>');
      //   }
      // });
    // Add Anchor Tag End

      // Upgrade Description Position Change Start
        const upgradeDesc = document.querySelector('.upgrade-desc');
        const upgradeTitleH2 = document.querySelector('.upgrade-title h2');
        
      if (window.innerWidth <= 989) {
        if (upgradeDesc && upgradeTitleH2) {
          upgradeTitleH2.insertAdjacentElement('afterend', upgradeDesc);
        }
      }
      // Upgrade Description Position Change End
});

// Download PDF Start
$('.faq b, .product__accordion strong').each(function () {
  if ($(this).text().trim().toLowerCase() === 'here') {
    $(this).css({
      cursor: 'pointer',
      textDecoration: 'underline',
      color: '#225458'
    });
  }
});
$(document).on('click', 'b, strong', function (e) {
  var $target = $(this);
  if ($target.text().trim().toLowerCase() === 'here') {
    e.preventDefault();
    var fileUrl =
      'https://cdn.shopify.com/s/files/1/0895/5992/5002/files/IInstallation_Guide_for_floor-standing_models.pdf?v=1770269397';
    var fileName = 'Installation_Guide.pdf';
    fetch(fileUrl)
      .then(function (response) {
        return response.blob();
      })
      .then(function (blob) {
        var blobUrl = window.URL.createObjectURL(blob);

        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(function () {
        // fallback
        window.location.href = fileUrl;
      });
  }
});
// Download PDF End

$(document).ready(function(){
  $('.header-hemburge').click(function(){
    $('.header__inline-menu').addClass('header__inline-menu-open')
  })
  $('.header-sidebar-close').click(function(){
    $('.header__inline-menu').removeClass('header__inline-menu-open')
  })
})

// Collection All Page Widget JS Start

document.addEventListener('DOMContentLoaded', () => {
  const widgetGrid = document.querySelector('.widget-grid');
  const widgetList = document.querySelector('.widget-list');
  const gridItems = () => document.querySelectorAll('.collection #product-grid .grid__item');

  if (widgetGrid) {
    widgetGrid.classList.add('active');

    widgetGrid.addEventListener('click', () => {
      gridItems().forEach(item => item.classList.remove('grid-widget-one'));
      widgetGrid.classList.add('active');
      if (widgetList) widgetList.classList.remove('active');
    });
  }

  if (widgetList) {
    widgetList.addEventListener('click', () => {
      gridItems().forEach(item => item.classList.add('grid-widget-one'));
      widgetList.classList.add('active');
      if (widgetGrid) widgetGrid.classList.remove('active');
    });
  }
});

const searchOutput = document.querySelector('#main-collection-filters');
const headerInput = document.querySelector('.facets-vertical-form');

if (window.innerWidth <= 749) {
    if (searchOutput && headerInput) {
        headerInput.appendChild(searchOutput);
    }
}

// Collection All Page Widget JS End

// Product Detail Page Accordion SVG Icon Change JS Start
// document.querySelectorAll('.product__accordion details').forEach(details => {
//   details.setAttribute('open', '');
// });
const firstDetails = document.querySelector('.product__accordion details');
if (firstDetails) {
  firstDetails.setAttribute('open', '');
}

document.querySelectorAll('.product__accordion summary .title-icon svg').forEach(svg => {
  svg.addEventListener('click', (event) => {
    event.stopPropagation(); // prevent summary toggle if needed
    
    svg.outerHTML = `
      <svg width="14" height="2" viewBox="0 0 14 2" fill="#16181D" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 1.75H1C0.59 1.75 0.25 1.41 0.25 1C0.25 0.59 0.59 0.25 1 0.25H13C13.41 0.25 13.75 0.59 13.75 1C13.75 1.41 13.41 1.75 13 1.75Z" fill="#16181D"/>
      </svg>
    `;
  });
});
// Product Detail Page Accordion SVG Icon Change JS End

// Privacy Policy Page Accordion arrow change JS Start
// Define your new SVG as a string
const plusSVG = `
<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#16181D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const minusSVG = `
<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#16181D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

document.addEventListener('DOMContentLoaded', () => {
  // Replace all SVGs with plusSVG on load
  document.querySelectorAll('.privacy-policy .policy-accordion .accordion svg').forEach(svg => {
    svg.outerHTML = plusSVG;
  });

  // Attach toggle event to each <details> inside accordions
  document.querySelectorAll('.privacy-policy .policy-accordion .accordion details').forEach(details => {
    details.addEventListener('toggle', () => {
      const svg = details.querySelector('svg');
      if (svg) {
        if (details.hasAttribute('open')) {
          svg.outerHTML = minusSVG;
        } else {
          svg.outerHTML = plusSVG;
        }
      }
    });
  });
});
// Privacy Policy Page Accordion arrow change JS End

// Mobile menu close JS Start
// Function to open the menu
// Select elements
const menu = document.querySelector('.header__inline-menu');
const openButton = document.querySelector('.header-mobile-open');
const closeButtons = document.querySelectorAll('.header-mobile-close');

// Function to open the menu
function openMenu() {
  menu.classList.add('header__inline-menu-open');
}

// Function to close the menu
function closeMenu() {
  menu.classList.remove('header__inline-menu-open');
}

// Open button click
if (openButton) {
  openButton.addEventListener('click', openMenu);
}

// Close button clicks
if (closeButtons.length > 0) {
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', closeMenu);
  });
}

const hembergeButton = document.querySelector('.header-hemburge');
const closeButton = document.querySelector('.header-mobile-close');
const overlay = document.querySelector('.overlay');

if (hembergeButton) {
  hembergeButton.addEventListener('click', function() {
    document.body.classList.add('overflow-hidden');
    overlay.classList.add('overlay-block');
  });
}

if (closeButton) {
  closeButton.addEventListener('click', function() {
    document.body.classList.remove('overflow-hidden');
    overlay.classList.remove('overlay-block');
  });
}

// Mobile menu close JS End

// Product Detail Page You may also like Slider JS Start
document.addEventListener('DOMContentLoaded', function () {
  if(document.querySelector('#recommendations-slider')){
      const slider = document.querySelector('#recommendations-slider');
      if (slider) {
        new Splide(slider, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '1rem',
          breakpoints: {
            1024: { perPage: 2 },
            640: { perPage: 1 },
          },
        }).mount();
      }
  }
 
});

// Get quote Form
if(document.querySelector('.get-a-quote')){
  document.querySelector('.get-a-quote').addEventListener('click', function() {
    document.querySelector('.ml-form-embedContainer').style.display = 'flex';
    document.body.classList.add('overflow-hidden');
  });
}

if(document.querySelector('.close-popup')){
  document.querySelector('.close-popup').addEventListener('click', function() {
    document.querySelector('.ml-form-embedContainer').style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  });
}
// Product Detail Page You may also like Slider JS End

// Sticky Header Start
window.addEventListener("scroll", function () {
  const header = document.querySelector(".header-wrapper");
  if (window.scrollY > 0) {
    header.classList.add("header-wrapper-sticky");
  } else {
    header.classList.remove("header-wrapper-sticky");
  }
});

// Sticky Header End

// Body overlay Open megamenu Start
$(document).ready(function(){
   $('#Details-HeaderMenu-3').on('click', function(event) {
    event.stopPropagation(); // Prevent this click from bubbling up
    const overlay = $('.overlay');
    const isVisible = overlay.css('display') === 'block';

    if (isVisible) {
      overlay.css('display', ''); // Hide
    } else {
      overlay.css('display', 'block'); // Show
    }
  });

  // Hide overlay if clicking anywhere outside
  $(document).on('click', function() {
    $('.overlay').css('display', '');
  });

  // Prevent overlay click from closing itself
  $('.overlay').on('click', function(event) {
    event.stopPropagation(); // Prevent bubbling to document
  });

  // Body Scroll Stop Start 
  let isOverlayOpen = false;

  $('#Details-HeaderMenu-3').click(function(event) {
    event.stopPropagation();
    
    if (isOverlayOpen) {
      $('body').css('overflow', '');
      isOverlayOpen = false;
    } else {
      $('body').css('overflow', 'hidden');
      isOverlayOpen = true;
    }
  });

  $(document).click(function() {
    if (isOverlayOpen) {
      $('body').css('overflow', '');
      isOverlayOpen = false;
    }
  });
  // Body Scroll Stop End 
// Body overlay Open megamenu End

  // Video Btn Start
//  $('.product-detail-video video').click(function() {
//   $('.product-detail-video span').css('display', 'none');
// });
  // Video Btn End

  $('#Details-HeaderMenu-3').click(function(){
    $('.mega-menu-open').toggleClass('mega-menu-show')
  });
  $(document).click(function (e) {
  // If the click target is NOT inside the mega menu or the header button
  if (
    !$(e.target).closest('.mega-menu-open').length &&
    !$(e.target).closest('#Details-HeaderMenu-3').length
  ) {
    $('.mega-menu-open').removeClass('mega-menu-show');
  }
});
});

document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".product-detail-video video");
  const span = document.querySelector(".product-detail-video span");

  if (video && span) {
    video.addEventListener("play", function () {
      span.style.opacity = "0";
    });
  }
});

// Text Replace Start
function replaceText() {
    const headingElement = document.querySelector('.swym-storefront-layout-login-heading');
    if (headingElement && headingElement.textContent.includes("Collections!")) {
      headingElement.innerHTML = headingElement.innerHTML.replace('Collections!', 'Product!');
    } else {
      setTimeout(replaceText, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', replaceText);

// Text Replace End

// Add image Start
const interval = setInterval(() => {
  const containerimg = document.querySelector('.swym-storefront-layout-empty-wishlist-content');
  if (containerimg) {
    clearInterval(interval);
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0895/5992/5002/files/paper_15241370.png?v=1748592050';
    img.alt = 'Empty Wishlist Image';
    containerimg.prepend(img);
  }
}, 500);
// Add image End

document.addEventListener('DOMContentLoaded', function () {
    const videoWrapper = document.querySelector('.product-detail-video');
    const video = document.querySelector('video');

    if (videoWrapper && video) {
      let isPlaying = false;

      videoWrapper.addEventListener('click', function () {
        if (isPlaying) {
          video.pause();
        } else {
          video.play();
        }
        isPlaying = !isPlaying;
      });
    }
  });


// product detail js START
  document.addEventListener("DOMContentLoaded", function () {
    const workTextDiv = document.querySelector('.work_text');
    const isVideoPage = document.querySelector('.product-detail-video');

    if (workTextDiv) {
      if (isVideoPage) {
        workTextDiv.style.display = 'block'; // Show if video page
      } else {
        workTextDiv.style.display = 'none';  // Hide otherwise
      }
    }
  });
// product detail js END